module.exports = __webpack_public_path__ + "img/numOne.eb544862.png";